import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';
import { useAuth } from './useAuth';
import type { Entitlement } from '../types';

export function useEntitlements() {
  const { user } = useAuth();
  const [entitlements, setEntitlements] = useState<Entitlement[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.email) {
      setEntitlements([]);
      setLoading(false);
      return;
    }

    const q = query(
      collection(db, 'entitlements'),
      where('email', '==', user.email),
      where('active', '==', true)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as Entitlement[];

      setEntitlements(data);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user?.email]);

  const hasAccess = (productId: string): boolean => {
    return entitlements.some(e => e.productId === productId && e.active);
  };

  return { entitlements, loading, hasAccess };
}
